import { render, staticRenderFns } from "./board-list-personal-report.vue?vue&type=template&id=71f9d21a&scoped=true&"
import script from "./board-list-personal-report.vue?vue&type=script&lang=js&"
export * from "./board-list-personal-report.vue?vue&type=script&lang=js&"
import style0 from "./board-list-personal-report.vue?vue&type=style&index=0&id=71f9d21a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9d21a",
  null
  
)

export default component.exports